/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_PlaceholderInputs */

const en_settings_placeholder = /** @type {(inputs: Settings_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your app content goes here.`)
};

const zh_settings_placeholder = /** @type {(inputs: Settings_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你的应用内容在这里。`)
};

/**
* | output |
* | --- |
* | "Your app content goes here." |
*
* @param {Settings_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const settings_placeholder = /** @type {((inputs?: Settings_PlaceholderInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_PlaceholderInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_placeholder(inputs)
	return zh_settings_placeholder(inputs)
});
export { settings_placeholder as "settings.placeholder" }